"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pictogram = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var PictogramAssets = require("./PictogramAssets");
var Pictogram = function (props) {
    var name = props.name, alt = props.alt, theme = props.theme, attributes = __rest(props, ["name", "alt", "theme"]) // tslint:disable-line
    ;
    var pictogramName = name;
    // The input name could be in short format("Cards48"), long format ("pictogramCards48"), or be a pathname ("pictograms/pictogramCards48.svg")
    // This regex will extract the name (Card) and size (48)
    var pictogramSize = 'small';
    var matches = name.match(/\/?(pictogram)?(([a-z]+)(\d+))(\.svg)?$/i);
    if (matches) {
        pictogramName = matches[2];
        // Get the size for the classname
        switch (matches[4]) {
            case '40':
                pictogramSize = 'xsmall';
                break;
            case '48':
                pictogramSize = 'small';
                break;
            case '64':
                pictogramSize = 'medium';
                break;
            case '128':
                pictogramSize = 'extralarge';
                break;
        }
    }
    if (typeof alt !== 'string' || alt.length === 0) {
        // Add aria-hidden when there is no alt text
        attributes['aria-hidden'] = true;
    }
    var imgSrc = theme ? PictogramAssets[theme.toLocaleLowerCase() + pictogramName] : PictogramAssets[pictogramName];
    if (imgSrc === null || imgSrc === void 0 ? void 0 : imgSrc.default) {
        imgSrc = imgSrc.default;
    }
    // Output the pictogram
    return (React.createElement("img", __assign({ className: "pictogram pictogram--" + pictogramSize, src: imgSrc, alt: alt }, attributes)));
};
exports.Pictogram = Pictogram;
// tslint:disable no-string-literal
exports.Pictogram['defaultProps'] = {
    alt: '',
};
exports.Pictogram['propTypes'] = {
    alt: PropTypes.string,
    name: PropTypes.oneOf(Object.keys(PictogramAssets).concat(Object.keys(PictogramAssets).map(function (name) { return "pictogram" + name; }))).isRequired,
};
// tslint:enable no-string-literal
